/** UTF-8 BOM helps Excel open CSV with special characters correctly. */
export function downloadCsv(filename: string, headers: string[], rows: (string | number)[][]): void {
  const esc = (cell: string | number) => {
    const s = String(cell ?? '');
    return `"${s.replace(/"/g, '""')}"`;
  };
  const lines = [headers.map(esc).join(','), ...rows.map((r) => r.map(esc).join(','))];
  const blob = new Blob([`\uFEFF${lines.join('\n')}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
